<template>
  <v-dialog v-model="dialog" persistent max-width="500px">
    <template #activator="{ on: dialogOn }">
      <app-tooltip top>
        <template #activator="{ on: tooltipOn }">
          <v-btn icon v-on="{ ...dialogOn, ...tooltipOn }">
            <resend-email-icon />
          </v-btn>
        </template>
        <span class="mediumTwo--text">Resend invite to user</span>
      </app-tooltip>
    </template>
    <v-card flat fill-height>
      <v-card-title>
        <h6 class="title">Resend Invite</h6>
      </v-card-title>
      <v-card-text>
        <v-layout column fill-height>
          <p>Resend invite to {{ email }}?</p>
        </v-layout>
        <v-divider />
        <v-layout fill-height justify-end class="pt-3">
          <app-button-cancel color="white lighten-2" @click="dialog = false">
            Cancel
          </app-button-cancel>
          <app-button color="primary" class="elevation-2" @click="resendInvite">
            Send
          </app-button>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import ResendEmailIcon from '@/assets/icons/ResendEmailIcon'
import { userService } from '@/services/user-service'
import { MyActiveOrganization } from '@/helpers/my-account-helper'

export default {
  components: { ResendEmailIcon },
  props: {
    email: { type: String, required: true },
    username: { type: String, required: true }
  },
  data() {
    return {
      dialog: false
    }
  },
  methods: {
    resendInvite(username) {
      userService.email(MyActiveOrganization.id, this.username)
      this.$emit('invite-resent', this.email)
      this.dialog = false
    }
  }
}
</script>
